import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  ContainerModel,
  ContainersResponseBody,
} from '@app/models/server/layout.model';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { EventService } from '@app/services/util-services/root-services/event-service';
import { HttpClientService } from '@app/services/util-services/root-services/http-client.service';
import {
  AsyncPipe,
  DOCUMENT,
  NgClass,
  NgComponentOutlet,
  NgStyle,
  NgTemplateOutlet,
} from '@angular/common';
import { FeatureListItemComponent } from '@app/new-ui-lib/b2b-list/components/b2b-feature-list/feature-list-item/feature-list-item.component';
import { B2bScrollLibModule } from '@app/b2b-scroll-lib/b2b-scroll-lib.module';
import { B2bScrollEndDirective } from '@app/b2b-scroll-lib/directives/b2b-scroll-end.directive';
import {
  catchError,
  concatMap,
  delay,
  Observable,
  of,
  Subject,
  Subscription,
  switchMap,
} from 'rxjs';
import { B2bDynamicLoaderPipe } from '@app/b2b-dynamic-lib/pipes/b2b-dynamic-loader-pipe.pipe';
import { B2bInformationCardComponent } from '@app/new-ui-lib/b2b-cards/components/b2b-information-card/b2b-information-card.component';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import { PromotionData } from '@app/models/server/promotion.model';
import { FEATURE_TYPES } from '@app/constants/app-settings';
import { ItemPromosComponent } from '@app/new-ui-lib/b2b-list/components/b2b-feature-list/item-promos/item-promos.component';
import { ItemDynPromosComponent } from '@app/new-ui-lib/b2b-list/components/b2b-feature-list/item-dyn-promos/item-dyn-promos.component';
import { B2bOlaMapComponent } from '@app/new-ui-lib/b2b-maps/b2b-ola-map/b2b-ola-map.component';
import { environment } from '@src/environments/environment';
import { ScrollSpyDirective } from '@app/components/directives/scroll-spy/scroll-spy.directive';
import { TapEffect } from '@app/components/directives/tap-effect.ts/tap-effect';
import { LoaderUtilService } from '@app/services/loader/loader-util.service';

@Component({
  selector: 'lib-feature-list-infinite-scroll',
  templateUrl: './feature-list-infinite-scroll.component.html',
  styleUrls: ['./feature-list-infinite-scroll.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    FeatureListItemComponent,
    B2bScrollLibModule,
    NgComponentOutlet,
    B2bDynamicLoaderPipe,
    B2bInformationCardComponent,
    NgTemplateOutlet,
    NgClass,
    ItemPromosComponent,
    ItemDynPromosComponent,
    NgStyle,
    B2bOlaMapComponent,
    ScrollSpyDirective,
    TapEffect,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureListInfiniteScrollComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() compData: {
    container?: ContainerModel;
    index?: number;
  } = {};

  @Input({ required: true }) isSeoPage: boolean;
  @Input() isMapView: boolean;

  @Output() changeMapView: EventEmitter<boolean> = new EventEmitter();

  rawListContainer: ContainerModel;
  otherRawContainers: ContainerModel[];

  // @ViewChild(IonContent, { static: false }) content: IonContent;

  /*@ViewChild('infiniteContainer', { static: true })
  infiniteContainerRef: ElementRef;*/

  @ViewChild(B2bScrollEndDirective)
  infiniteScroll: B2bScrollEndDirective;

  @ViewChild(B2bOlaMapComponent) mapComp: B2bOlaMapComponent;

  // @ViewChild('appScrollSpyDirective') appScrollSpyDirective: ScrollSpyDirective;

  page: number = Number(1);
  size: number = Number(10);
  finalFilterValues: { [key: string]: any } = {};
  showInfiniteScroll: boolean = Boolean(false);

  loadOtherProperties: boolean = Boolean(false);

  showLoader$: Observable<boolean> = of(true);
  showLoader = true;

  errorCodes: string[] = [];
  queryParams: Params = {};

  initAPISubscription$: Subscription;

  finalContainerItems: ContainerModel[] = [];
  $finalContainerItems: Observable<ContainerModel[]>;

  otherPropertiesContainerItems: ContainerModel[] = [];
  $otherPropertiesContainerItems: Observable<ContainerModel[]>;

  mapProperties: ContainerModel[] = [];
  mapConfig: any;

  promotionData: PromotionData;

  localitiesErrorContainers: ContainerModel[] = [];
  // $localitiesErrorContainers: Observable<ContainerModel[]>;

  finalErrorContainers: ContainerModel[] = [];
  showLoadMoreButton = false;

  showMapView = false;
  mapLoaded = false;
  mapPositionSubject: Subject<{ lat: number; lng: number }> = new Subject<{
    lat: number;
    lng: number;
  }>();

  loadMoreDataSubject: Subject<any> = new Subject<any>();

  isServer: boolean = this.b2bDeviceUtilService?.isServer();
  featureType: string;

  // List view
  showGridView: boolean = false;
  loadDynamicPromosAfter: number = 3;
  loadStaticPromosAfter: number = 3;

  F_TYPES = FEATURE_TYPES;

  // $finalErrorContainers: Observable<ContainerModel[]>;
  selectedMapProperty: ContainerModel;
  // selectedMapProperty$: Observable<ContainerModel>;

  protected readonly environment = environment;
  startPropertyStreaming = false;

  showMapLoader: boolean = false;

  markerClickEventSubscription$: Subscription;
  retrievePageEventSubscription$: Subscription;
  filterChangeEventSubscription$: Subscription;
  refreshListEventSubscription$: Subscription;
  clearAllFilterEventSubscription$: Subscription;
  destroyPageEventSubscription$: Subscription;
  mapPositionSubjectSubscription$: Subscription;
  loadMoreDataSubjectSubscription$: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private httpClientService: HttpClientService,
    @Inject(DOCUMENT) private readonly document: Document,
    private cdref: ChangeDetectorRef,
    private b2bDeviceUtilService: B2bDeviceUtilService,
    private loaderUtilService: LoaderUtilService,
  ) {
    this.setListView();
  }

  ngAfterViewInit(): void {}

  ngOnInit() {
    this.showMapView = this.isMapView;
    this.initApi();
    this.retrievePageEventSubscription$ =
      this.eventService?.retrievePageEvent?.subscribe((event: any) => {
        if (!this.isServer) {
          setTimeout(() => {
            this.onSelectMapProperty(this.selectedMapProperty);
          }, 1000);
        }
      });

    this.destroyPageEventSubscription$ =
      this.eventService.destroyListPageComponents?.subscribe((event: any) => {
        this.ngOnDestroy();
      });

    this.mapPositionSubjectSubscription$ = this.mapPositionSubject
      .pipe(
        concatMap((position: { lat: number; lng: number }) => {
          this.showMapLoader = true;
          return this.loadMoreDataForMap(null, 1, position);
        }),
      )
      .subscribe((result: ContainerModel[]) => {
        this.showMapLoader = false;

        this.cdref.markForCheck();
      });

    this.loadMoreDataSubjectSubscription$ = this.loadMoreDataSubject
      .pipe(
        concatMap((payload: any) => {
          return this.loadMoreData({});
        }),
      )
      .subscribe((result: ContainerModel[]) => {
        // this.cdref.markForCheck();
      });
  }

  initApi() {
    this.initAPISubscription$ = this.httpClientService
      ?.getDynamicContainersData(
        this.compData?.container?.apiURL,
        this.compData?.container?.isCacheEnabled,
        this.compData?.container?.key,
        this.compData?.container?.apiRequestBody,
        null,
        true,
      )
      .pipe(
        switchMap((containerResponseBody: ContainersResponseBody) => {
          this.rawListContainer = containerResponseBody?.listContainer;
          if (containerResponseBody?.listContainer?.feature?.type) {
            this.featureType =
              containerResponseBody?.listContainer?.feature?.type;
            if (
              this.featureType === FEATURE_TYPES.SHORTSTAY_PACKAGE &&
              this.b2bDeviceUtilService?.isDesktop()
            ) {
              this.setGridView();
            }
          }
          if (this.compData?.container?.seoContent?.title) {
            if (containerResponseBody?.headerContainer?.length > 0) {
              for (const container of containerResponseBody?.headerContainer) {
                if (container?.key === 'heading_container') {
                  container.subTitle =
                    this.compData?.container?.seoContent?.title;
                }
              }
            }
            this.otherRawContainers = containerResponseBody?.headerContainer;
          } else {
            this.otherRawContainers = containerResponseBody?.headerContainer;
          }
          this.promotionData = containerResponseBody?.promotionContainer;
          if (this.showMapView) {
            this.setMapView(
              containerResponseBody?.listContainer?.containers,
              true,
            );
          }
          return of(containerResponseBody);
        }),
      )
      .subscribe({
        next: (containers: ContainersResponseBody) => {
          this.resetShowInfiniteScroll();
          this.setFinalContainerItems();
          this.initAfterApiCall();
        },
        error: (errorResponse: HttpErrorResponse) => {
          this.productsErrorHandling(errorResponse, false);
        },
      });
  }

  setGridView() {
    this.showGridView = true;
    this.loadDynamicPromosAfter = 4;
    this.loadStaticPromosAfter = 2;
  }

  setListView() {
    this.showGridView = false;
    this.loadDynamicPromosAfter = 3;
    this.loadStaticPromosAfter = 3;
  }

  initAfterApiCall() {
    if (Number(this.rawListContainer?.apiRequestBody?.queryParams?.s) > 0) {
      this.page = Math.ceil(
        Number(this.rawListContainer?.apiRequestBody?.queryParams?.s) / 10,
      );
    }

    if (this.rawListContainer?.apiRequestBody?.queryParams) {
      this.queryParams = this.rawListContainer?.apiRequestBody?.queryParams;
    }

    // TODO need to test feature by removing below code
    /*this.route.queryParams.subscribe({
      next: (value: Params) => {
        // LoggerService.log('Inside this.route.queryParams ', value);
        // this.query = value?.query;
        if (value && Object.entries(value)?.length > 0) {
          this.queryParams = value;

        }

      },
    });*/

    this.filterChangeEventSubscription$ =
      this.eventService.filterChangeEvent.subscribe({
        next: (result: { filterValues: { [key: string]: any } }) => {
          Object.entries(result?.filterValues).forEach((entry) => {
            const key: string = entry[0];
            const value: any = entry[1];
            this.finalFilterValues[key] = value;
          });

          if (this.showMapView) {
            // TODO handle filter locality values differently for map view
          }

          // common approach for both map and list view
          this.eventService.finalFilterValuesChangeEvent.emit({
            finalFilterValues: this.finalFilterValues,
          });

          this.filterData();
        },
      });

    this.refreshListEventSubscription$ =
      this.eventService.refreshListEvent.subscribe({
        next: (result: any) => {
          this.refreshData();
        },
      });

    this.clearAllFilterEventSubscription$ =
      this.eventService.clearAllFilterEvent.subscribe({
        next: (result: { onlyResetValues: boolean }) => {
          this.finalFilterValues = {};
          if (!result?.onlyResetValues) {
            this.filterData();
          }
        },
      });

    this.markerClickEventSubscription$ =
      this.eventService.markerClickEvent?.subscribe({
        next: (result: { container: ContainerModel }) => {
          // this.selectedMapProperty = result?.container;
          this.onSelectMapProperty(result?.container);
          // this.openMapPropertyModal();
          // this.cdref?.markForCheck();
        },
      });

    if (!this.b2bDeviceUtilService?.isServer()) {
      this.callLoadMoreForcefully();
    }

    // this.resetShowInfiniteScroll();
    // this.setFinalContainerItems();
  }

  updateQueryParams(params: { queryParams: any }) {
    this.router
      .navigate(['.'], {
        relativeTo: this.route,
        queryParams: params?.queryParams,
      })
      .then();
  }

  trackByFn(index: number, item: any) {
    return item ? item.uid : undefined;
  }

  fireLoadMoreDataEvent(event: any) {
    if (this.showMapView) {
      return;
    }
    this.loadMoreDataSubject.next({});
  }

  public loadMoreData(event: any): Observable<ContainerModel[]> {
    this.showLoader = true;
    this.showLoader$ = of(this.showLoader);
    this.cdref?.markForCheck();
    this.page = this.page + 1;
    return this.getProducts(
      this.page,
      this.size,
      this.finalFilterValues,
      false,
      false,
      null,
      false,
    );
  }

  public loadMoreDataForMap(
    event: any,
    page: number,
    center: { lat: number; lng: number },
  ): Observable<ContainerModel[]> {
    // this.showLoader = true;
    // this.showLoader$ = of(this.showLoader);
    // this.cdref?.markForCheck();
    // this.page = page;

    return this.getProducts(
      page,
      this.size,
      this.finalFilterValues,
      false,
      false,
      center,
      false,
    );
  }

  productsErrorHandling(
    errorResponse: HttpErrorResponse,
    isScrollToTop: boolean,
  ) {
    this.showLoader = false;
    this.showLoader$ = of(this.showLoader);
    if (errorResponse?.error?.errorCode === 'locality_properties_not_found') {
      this.localitiesErrorContainers = errorResponse?.error?.errorContainer;
      this.errorCodes?.push('locality_properties_not_found');
      this.loadOtherProperties = true;
      this.loadOtherPropertiesData();
    } else if (errorResponse?.error?.errorCode === 'properties_not_found') {
      this.finalErrorContainers = errorResponse?.error?.errorContainer;
      this.toggleInfiniteScroll();
      /*if (isRefreshEvent) {
              this.eventService.refresherChangeEvent.emit();
            }*/
      if (isScrollToTop) {
        // LoggerService.warn('Scroll to top called');
        this.scrollToTop();
      }
      if (this.finalContainerItems?.length > 0) {
        this.errorCodes?.push('properties_not_found');
      } else {
        this.errorCodes = ['properties_not_found'];
      }
    } else {
      this.finalErrorContainers = errorResponse?.error?.errorContainer;
      this.toggleInfiniteScroll();
      /*if (isRefreshEvent) {
              this.eventService.refresherChangeEvent.emit();
            }*/
      if (isScrollToTop) {
        // LoggerService.warn('Scroll to top called');
        this.scrollToTop();
      }
      if (this.finalContainerItems?.length > 0) {
        this.errorCodes?.push('properties_not_found');
      } else {
        this.errorCodes = ['properties_not_found'];
      }
    }
    this.cdref?.markForCheck();
  }

  callLoadMoreForcefully() {
    if (this.page === 1 && this.finalContainerItems?.length < this.size) {
      if (this.queryParams && Object.entries(this.queryParams)?.length > 0) {
        this.fireLoadMoreDataEvent({});
      } else {
        if (
          this.route?.snapshot?.queryParams &&
          Object.entries(this.route?.snapshot?.queryParams)?.length > 0
        ) {
          this.queryParams = this.route?.snapshot?.queryParams?.query;
          this.fireLoadMoreDataEvent({});
        }
      }
    }
    this.showLoadMoreButton = true;
  }

  private loadOtherPropertiesData() {
    this.showLoader = true;
    this.showLoader$ = of(this.showLoader);
    this.cdref?.markForCheck();
    this.page = 1;
    this.getProducts(
      this.page,
      this.size,
      this.finalFilterValues,
      false,
      false,
      null,
      false,
    ).subscribe();
  }

  private filterData() {
    this.resetData();
    this.showLoader = true;
    this.showLoader$ = of(this.showLoader);
    this.cdref?.markForCheck();
    this.page = 1;
    this.getProducts(
      this.page,
      this.size,
      this.finalFilterValues,
      false,
      true,
      null,
      true,
    ).subscribe();
  }

  private refreshData() {
    this.resetData();
    this.showLoader = true;
    this.showLoader$ = of(this.showLoader);
    this.cdref?.markForCheck();
    this.page = 1;
    this.getProducts(
      this.page,
      this.size,
      this.finalFilterValues,
      true,
      true,
      null,
      true,
    ).subscribe();
  }

  private getProducts(
    page: number,
    size: number,
    finalFilterValues: { [key: string]: any },
    isRefreshEvent: boolean,
    isScrollToTop: boolean,
    center: { lat: number; lng: number },
    overrideProperties: boolean,
  ): Observable<ContainerModel[]> {
    if (this.queryParams && Object.entries(this.queryParams)?.length > 0) {
    } else {
      return of([]);
    }

    let loadedIds: string[] = [];
    if (this.showMapView) {
      if (this.mapProperties?.length > 0) {
        loadedIds = [...this.mapProperties?.map((item) => item?.uid)];
      }
    } else {
      if (
        this.finalContainerItems?.length > 0 ||
        this.otherPropertiesContainerItems?.length > 0
      ) {
        loadedIds = [
          ...this.finalContainerItems?.map((item) => item?.uid),
          ...this.otherPropertiesContainerItems?.map((item) => item?.uid),
        ];
      }
    }

    /*this.showLoader = true;
    this.showLoader$ = of(this.showLoader);*/
    // this.cdref?.markForCheck();
    return this.httpClientService
      .post(
        // 'feature-list/load-more',
        'feature-list/new-load-more',
        {
          page,
          size: this.size,
          filterValues: finalFilterValues,
          loadOtherProperties: this.loadOtherProperties,
          loadedIds,
          queryParams: this.queryParams,
          clat: center?.lat,
          clng: center?.lng,
        },
        {},
        true,
      )
      .pipe(
        switchMap((containerItems: ContainerModel[]) => {
          if (!this.showMapView) {
            this.rawListContainer.containers = containerItems;
            this.setFinalContainerItems();
            if (!this.loadOtherProperties) {
              this.callLoadMoreForcefully();
            }
            if (isScrollToTop) {
              this.scrollToTop();
            }
            // this.mapLoaded = true;
          } else {
            // this.showLoader = false;
            // this.showLoader$ = of(this.showLoader);
            if (overrideProperties) {
              this.rawListContainer.containers = containerItems;
              this.setFinalContainerItems();
            }
            this.setMapView(containerItems, overrideProperties);
          }
          return of(containerItems);
        }),
        catchError((errorResponse: HttpErrorResponse) => {
          this.productsErrorHandling(errorResponse, isScrollToTop);
          this.startPropertyStreaming = false;
          return of([]);
        }),
      );
  }

  private setFinalContainerItems() {
    if (this.loadOtherProperties) {
      if (!this.otherPropertiesContainerItems) {
        this.otherPropertiesContainerItems = [];
      }

      const inStockProducts: ContainerModel[] =
        this.rawListContainer?.containers?.filter((item: ContainerModel) => {
          return !item.isSoldOut;
        });
      if (inStockProducts?.length > 0) {
        this.otherPropertiesContainerItems = [
          ...this.otherPropertiesContainerItems,
          ...inStockProducts,
        ];
      }

      this.$otherPropertiesContainerItems = of(
        this.otherPropertiesContainerItems,
      );
    } else {
      if (!this.finalContainerItems) {
        this.finalContainerItems = [];
      }

      this.finalContainerItems = [
        ...this.finalContainerItems,
        ...this.rawListContainer?.containers,
      ];

      this.$finalContainerItems = of(this.finalContainerItems);
      this.showLoader = false;
      this.showLoader$ = of(this.showLoader);
    }
    this.cdref.markForCheck();
  }

  private toggleInfiniteScroll() {
    if (this.infiniteScroll) {
      this.infiniteScroll.disabled = !this.infiniteScroll.disabled;
    }
  }

  private completeInfiniteScroll() {
    // this.infiniteScroll.complete().then();
  }

  private scrollToTop() {
    if (!this.isServer) {
      const element = this.document?.getElementById('s-to-top');
      setTimeout(() => {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        });
      }, 500);
    }
  }

  private resetData(): boolean {
    this.rawListContainer.data = [];
    this.finalContainerItems = [];
    this.otherPropertiesContainerItems = [];
    this.mapProperties = [];
    this.$finalContainerItems = of(this.finalContainerItems);
    this.$otherPropertiesContainerItems = of(
      this.otherPropertiesContainerItems,
    );
    this.loadOtherProperties = false;
    // this.soldOutContainerItems = [];
    this.showInfiniteScroll = false;
    this.errorCodes = [];
    // this.page = 1;
    this.finalErrorContainers = [];
    this.localitiesErrorContainers = [];
    // this.errorContainers = [];
    if (this.infiniteScroll) {
      this.infiniteScroll.disabled = false;
    }
    // this.scrollToTop();
    this.resetShowInfiniteScroll();
    // this.cdref?.markForCheck();
    return true;
  }

  private resetShowInfiniteScroll() {
    of(true)
      .pipe(delay(1000))
      .subscribe({
        next: (value) => (this.showInfiniteScroll = value),
      });
  }

  setMapView(containers: ContainerModel[], override: boolean) {
    if (!this.mapProperties) {
      this.mapProperties = [];
    }
    if (containers?.length > 0) {
      if (override) {
        this.mapProperties = [...JSON.parse(JSON.stringify(containers))];
      } else {
        this.mapProperties = [
          ...this.mapProperties,
          ...JSON.parse(JSON.stringify(containers)),
        ];
      }
    }

    let selectedLocations = [];
    if (this.finalFilterValues.LOCALITY_FILTERS?.length > 0) {
      selectedLocations = this.finalFilterValues.LOCALITY_FILTERS;
    }

    this.mapConfig = {
      mapProperties: this.mapProperties,
      overrideData: override,
      locations: selectedLocations,
    };

    if (this.mapComp) {
      if (override) {
        this.mapComp?.resetMapWithNewData(
          this.mapConfig?.mapProperties,
          this.mapConfig?.locations,
        );
      } else {
        this.mapComp?.loadPropertyMarkers(this.mapConfig?.mapProperties);
      }
    } else {
      // TODO don't know what to do in this case
    }
  }

  toggleView() {
    this.loaderUtilService.show('Loading Map View', {
      backdrop: true,
      duration: this.showMapView ? 1200 : 3000,
    });
    this.showMapView = !this.showMapView;
    this.mapLoaded = true;
    if (this.showMapView) {
      this.setMapView(this.finalContainerItems, true);
      // this.startPropertyStreamingForMap(this.page);
    }
    this.changeMapView.emit(this.showMapView);
  }

  onMapCenterChanged(event: { lat: number; lng: number }) {
    this.mapPositionSubject.next(event);
  }

  onSelectMapProperty(mapProperty: ContainerModel) {
    this.selectedMapProperty = mapProperty;
    const propertyElement: HTMLElement = this.document?.getElementById(
      'mv-' + this.selectedMapProperty?.uid,
    );

    if (propertyElement) {
      propertyElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start',
      });
    }
    this.cdref?.markForCheck();
  }

  onActiveProperty(propertyDivId: string) {
    if (propertyDivId) {
      const propertyId: string = propertyDivId?.substring(3)?.trim();
      this.activatePropertyMarker(propertyId);
    }
  }

  activatePropertyMarker(propertyId: string) {
    if (this.mapComp) {
      const foundedProperty: ContainerModel = this.mapProperties?.find(
        (property: ContainerModel) => {
          return property?.uid === propertyId;
        },
      );
      if (foundedProperty) {
        this.mapComp.activatePropertyMarker(foundedProperty);
      }
    }
  }

  ionViewDidLeave(): void {
    this.unsubscribe();
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  unsubscribe() {
    if (this.initAPISubscription$) {
      this.initAPISubscription$?.unsubscribe();
    }
    if (this.markerClickEventSubscription$) {
      this.markerClickEventSubscription$?.unsubscribe();
    }
    if (this.filterChangeEventSubscription$) {
      this.filterChangeEventSubscription$?.unsubscribe();
    }
    if (this.refreshListEventSubscription$) {
      this.refreshListEventSubscription$?.unsubscribe();
    }
    if (this.clearAllFilterEventSubscription$) {
      this.clearAllFilterEventSubscription$?.unsubscribe();
    }
    if (this.destroyPageEventSubscription$) {
      this.destroyPageEventSubscription$?.unsubscribe();
    }
    if (this.mapPositionSubjectSubscription$) {
      this.mapPositionSubjectSubscription$?.unsubscribe();
    }
    if (this.loadMoreDataSubjectSubscription$) {
      this.loadMoreDataSubjectSubscription$?.unsubscribe();
    }
  }
}
